import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { triggerPoll } from '../api';
import { toast } from '../toast';

export default function ShakeToRefresh() {
  const qc = useQueryClient();
  const cooldown = useRef(0);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    let last: number | null = null;
    const THRESHOLD = 14; // m/s^2 of |a|
    function onMotion(e: DeviceMotionEvent) {
      const a = e.accelerationIncludingGravity;
      if (!a) return;
      const mag = Math.sqrt((a.x ?? 0) ** 2 + (a.y ?? 0) ** 2 + (a.z ?? 0) ** 2);
      const t = Date.now();
      if (last && (mag > 9.8 + THRESHOLD) && t - cooldown.current > 4000) {
        cooldown.current = t;
        toast.info('Refreshing…');
        triggerPoll().finally(() => qc.invalidateQueries());
      }
      last = mag;
    }
    window.addEventListener('devicemotion', onMotion);
    return () => window.removeEventListener('devicemotion', onMotion);
  }, [qc]);

  return null;
}
